<script>
import Modal from '@/components/atoms/Modal'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import { EventBus } from '@/modules/plugins/modules/event'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import FormValidation from '@/components/atoms/FormValidation'
import ModalForgotPassword from '@/components/organism/modal/ModalForgotPassword'
import { mapGetters } from 'vuex'
export default {
    name: 'ModalLogin',
    components: {
        ModalForgotPassword,
        FormValidation,
        ButtonLoader,
        InputLine,
        Modal,
    },
    data() {
        return {
            loading: false,
            disabled: true,
            error: null,
            model: {
                email: null,
                password: null,
            },
        }
    },
    computed: {
        ...mapGetters({
            orderAddress: 'order/address',
            orderRestaurant: 'order/restaurant',
        }),
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
    },
    methods: {
        login() {
            this.loading = true
            this.error = null
            this.$user
                .login(this.model)
                .then(async () => {
                    this.close()
                    this.$nextTick(async () => {
                        await this.$addresses.initAddresses()
                        await this.$filteredAddresses.fetch(
                            {},
                            { restaurant: this.orderRestaurant.id }
                        )
                        const storedAddress = this.$addresses.findAddress(this.orderAddress)
                        if (storedAddress?.model)
                            this.$location.select.set(storedAddress.model, false)
                        else {
                            this.$cart.setPhone(this.$user.model, this.orderAddress)
                            this.$cart.calculate()
                        }
                    })
                    await this.$store.dispatch('checkout/stripeInitAfterLogin')
                })
                .catch((e) => {
                    this.error = e.message
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onChange() {
            this.error = null
        },
        open() {
            this.$refs.ModalLogin.openModal()
        },
        close() {
            EventBus.$emit('closeAllModals')
        },
        submit() {
            this.$refs.form.formSubmit()
        },
        disableForm(val) {
            this.disabled = val
        },
        reset() {
            this.model = {
                email: null,
                password: null,
            }
        },
    },
}
</script>

<template lang="pug">
modal(ref="ModalLogin" @closed="reset" @close="reset" sm)
    template(v-slot:header)
        .modal-header-text {{$t('login.sign_in')}}
    template(v-slot:body)
        form-validation(@submit="login" @disable="disableForm" ref="form")
            input-line(v-model="model.email" type="email" @input="onChange" :error="error !== null" :placeholder="$t('labels.placeholder.email')" live required)
            input-line(v-model="model.password" type="password" @input="onChange"  :error="error" :placeholder="$t('labels.placeholder.psw')" live required)
            template(v-slot:submit)
                button-loader.btn.btn-primary.btn-block(inline type="submit" :loading="loading") {{$t('login.log_in')}}
        modal-forgot-password
    template(v-slot:footer)
        .text-center
            p.mb-0.text-73.primary-link(v-html="$t('login.no_account', {link: 'signup'})")
</template>
